import { configureWithRelationshipSerializer, configurePaginatedSerializer } from './utils';

const PageWithRelationshipsSerializer = configureWithRelationshipSerializer({
  includeForeignModelAttrs: {
    type: ['name'],
    parentPage: ['title'],
    competition: ['name'],
    event: ['name'],
    modifiedBy: ['name'],
    publishedBy: ['name'],
    createdBy: ['name'],
  },
});

const PaginatedPageSerializer = configurePaginatedSerializer({ baseSerializer: PageWithRelationshipsSerializer });

export default {
  page: PageWithRelationshipsSerializer,
  paginatedPages: PaginatedPageSerializer,
};
